export default __webpack_public_path__ + "static/media/ic_american_samoa.dceadb25.svg";